<div class="why__us">
  <div class="container mx-auto">
    <div class="why__header">
      <h2 translate="Why Us"></h2>
      <h3 translate="Why Choose Our Platform?"></h3>
      <p translate>
        Discover the benefits that set us apart and make your online management
        effortless
      </p>
    </div>

    <div class="why__content mt-8">
      <div class="why__cards">
        <div class="why__card">
          <div class="card__icon" inlineSVG="why-us/secure.svg"></div>
          <h3 class="card__title" translate>Secure</h3>
          <p class="card__desc" translate>
            We ensure safe use with HTTPS and 24/7 protection from our security
            team.
          </p>
        </div>
        <div class="why__card">
          <div class="card__icon" inlineSVG="why-us/monetization.svg"></div>
          <h3 class="card__title" translate>Monetization</h3>
          <p class="card__desc" translate>
            Generate income by embedding ads in your QR codes and URLs, and
            effortlessly profit from digital interactions.
          </p>
        </div>
      </div>

      <div class="why__logo reverse__row-direction">
        <div class="line__container left__lines">
          <div
            class="row__direction flex items-center flex-row-reverse line__one"
          >
            <div class="dotted__line" inlineSVG="why-us/line.svg"></div>
            <div
              class="dotted__line top__left"
              inlineSVG="why-us/angle-line.svg"
            ></div>
          </div>

          <div
            class="row__direction flex items-center flex-row-reverse line__two"
          >
            <div class="dotted__line" inlineSVG="why-us/line.svg"></div>
            <div
              class="dotted__line bottom__left"
              inlineSVG="why-us/angle-line.svg"
            ></div>
          </div>
        </div>
        <div>
          <div class="logo" inlineSVG="nav/logo.svg"></div>
        </div>
        <div class="line__container right__lines">
          <div class="reverse__row-direction flex items-center line__three">
            <div class="dotted__line" inlineSVG="why-us/line.svg"></div>
            <div
              class="dotted__line top__right"
              inlineSVG="why-us/angle-line.svg"
            ></div>
          </div>

          <div class="reverse__row-direction flex items-center line__four">
            <div class="dotted__line" inlineSVG="why-us/line.svg"></div>
            <div
              class="dotted__line bottom__right"
              inlineSVG="why-us/angle-line.svg"
            ></div>
          </div>
        </div>
      </div>

      <div class="why__cards">
        <div class="why__card">
          <div class="card__icon" inlineSVG="why-us/wallet.svg"></div>
          <h3 class="card__title" translate>Free And Easy</h3>
          <p class="card__desc" translate>
            We offer simple, free tools that save you money and time. Our tools
            are easy to use and free forever.
          </p>
        </div>
        <div class="why__card">
          <div class="card__icon" inlineSVG="why-us/secure.svg"></div>
          <h3 class="card__title" translate>Editable</h3>
          <p class="card__desc" translate>
            You can save and modify your tool data anytime through your control
            panel, like with our link shortening service.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
